import numbro from 'numbro';
import {FC} from 'react';

type FormatUsdCurrencyProps = {
    number?: number | string | null;
    options?: {decimals?: number;};
    numbroOptions?: numbro.Format;
};

export const formatUsdCurrency = (
    number: number,
    options: {decimals?: number;} = {},
    numbroOptions?: numbro.Format,
): string => {
    const result = numbro(number).format({
        output: 'currency',
        currencySymbol: 'USD',
        spaceSeparated: true,
        ...numbroOptions,
        mantissa: options.decimals === undefined ? 2 : options.decimals,
    });
    return result.replace(' ', '\u00A0');
};

export const FormatUsdCurrency: FC<FormatUsdCurrencyProps> = ({number, options, numbroOptions}) => {
    if (typeof number === 'string') number = +number;
    if (number === undefined || number === null) return <>-</>;
    return <>{formatUsdCurrency(number, options, numbroOptions)}</>;
};
